import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { SilentRenewPage } from "./auth/SilentRenewPage";
import "./styles/command-center.css";

const root = ReactDOM.createRoot(document.getElementById("root")!);

// OIDC silent-renew runs inside a hidden iframe at /auth/silent-renew. Render only the
// renew handler there — booting the full app (DataProvider polling, etc.) in the iframe
// would be wasteful and can deadlock the renew handshake.
if (window.location.pathname === "/auth/silent-renew") {
  root.render(<SilentRenewPage />);
} else {
  root.render(
    <React.StrictMode>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
}
